<template>

    <div class="container">

        <app-head :title="page.meta_title || page.title">
            <meta name="description" :content="page.meta_description" v-if="page.meta_description">
        </app-head>

        <article class="page">

            <div class="my-4 page__title">
                <h1>{{ page.title }}</h1>
            </div>

            <div class="page__content" v-html="page.content">
            </div>

        </article>

    </div>

</template>

<script>

    export default {
        props: [
            'page',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>